import '../../sass/general/index.scss';
import 'react-toastify/dist/ReactToastify.css';
import CTaskQueryParameter from '../../components/General/ctask_guery_parameter/CTaskQueryParameter';
import React, {useEffect, useMemo} from 'react';
import MainContainer from '../../components/MainContainer';
import RegisterBlock from '../../components/Registraion/RegisterBlock';
import { ReactComponent as CleanTalkLogo } from '../../svg/filled/cleantalklogo.svg';
import { ReactComponent as CleanTalkLogoText } from '../../svg/cleantalklogo-text.svg';
import Select, { components } from 'react-select';
import { FEATURED_PRODUCTS_PAIR } from '../../constants/constants';
import { ReactComponent as ChevronDown } from '../../svg/chevron-down.svg';
import { connect } from 'react-redux';
import {productAvailableAccountsSelector, productCurrentProductIdSelector} from '../../redux/selectors/productSelector';
import { saveProductId } from '../../redux/actions/pagesActions';
import { ToastContainer, Bounce } from 'react-toastify';
import init from '../init';
import Footer from '../../components/Footer/Footer';
import useQuery from "../../hooks/useQuery";
import {setPeriodFromQuery} from "../../redux/actions/cartAction";

function Main({ mainProductId, setProductId, accountsList, setPeriod }) {
    // Init stands to a single entry point with a dedicated functional script(s)
    // start-up actions execution (like setting up "page opened" cookie).
    init({ mainProductId });

    const options = useMemo(() => {
        const options = [];
        for (const i in FEATURED_PRODUCTS_PAIR) {
            if (!!FEATURED_PRODUCTS_PAIR[i].allowedAsSeparate) {
                options.push({
                    value: +i,
                    label: FEATURED_PRODUCTS_PAIR[i].name,
                    description: FEATURED_PRODUCTS_PAIR[i].description,
                    isDisabled: !FEATURED_PRODUCTS_PAIR[i].active,
                });
            }
        }

        return options;
    }, [FEATURED_PRODUCTS_PAIR]);

    const Option = (props) => {
        return (
            <components.Option {...props}>
                <div>
                    <p className={'title'}>{props.data.label}</p>
                    <p className={'description'}>{props.data.description}</p>
                </div>
            </components.Option>
        );
    };

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <ChevronDown className={'icon'} />
            </components.DropdownIndicator>
        );
    };

    const query = useQuery();
    useEffect(() => {
        if(accountsList?.find(item => +item.account_id === +query.get('account'))?.trial && +query.get('product_id') === 7){
            setPeriod({
                period: 'Month',
                interval: '1',
            });
        }
    }, [accountsList])

    return (
        <>
            <CTaskQueryParameter />
            <header className="header">
                <div className="container mobile-side-gap header__container">
                    <a className={'header__logo-link'} href="https://cleantalk.org/my">
                        <CleanTalkLogo className={'header__logo-icon'} />
                        <CleanTalkLogoText className={'header__logo-text icon'} />
                    </a>
                    <div className="container container--main flex flex--end full-width flex--mobile-space-between">
                        <Select
                            options={options}
                            className={'filter__selector ml-2 product-selector'}
                            classNamePrefix="filter"
                            isSearchable={true}
                            components={{
                                DropdownIndicator,
                                Option,
                            }}
                            onChange={(e) => {
                                setProductId(Number(e.value));
                            }}
                            isOptionDisabled={(option) => option?.isDisabled}
                            defaultValue={options
                                .filter((option) => option.value === mainProductId)
                                .shift()}
                            value={options.filter((option) => option.value === mainProductId).shift()}
                            // menuIsOpen={true}
                        />
                        <RegisterBlock />
                    </div>
                </div>
            </header>
            <main className="main">
                <MainContainer product_id={mainProductId} />
            </main>
            <footer className="footer">
                <Footer />
            </footer>
            <ToastContainer
                position='bottom-center'
                autoClose={8000}
                hideProgressBar={true}
                stacked={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable={false}
                pauseOnHover
                theme="light"
                transition={Bounce}
            />
        </>
    );
}

const mapStateToProps = (state) => ({
    mainProductId: productCurrentProductIdSelector(state),
    accountsList: productAvailableAccountsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    setProductId: (data) => dispatch(saveProductId(data)),
    setPeriod: (data) => dispatch(setPeriodFromQuery(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
